import React from 'react'
import cn from 'classnames'
import Icon from 'components/common/elements/Icon'
import { connect } from "react-redux";
import { logout } from "store/auth/actions";

import styles from "../Menu/Menu.scss";

const UserMenu = ({ logout, isMenuOpen }) => {
  return (
    <div onClick={logout} className={styles.navigation} style={{flex: 0, cursor: 'pointer'}}>
        <div className={cn('MenuIcon', {onlyIcon: !isMenuOpen})}>
          <Icon icon="out" size={46} role="button" />
          <span className="gs-text" role="button"> Logout </span>
        </div>
    </div>
  )
}

export default connect(null, {logout})(UserMenu)
